import * as yup from 'yup';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  avatarImage,
  fileStatus,
  nameFormat,
  typeImageFiles,
  typeVideoFiles,
  userFilesCode,
  videoFile
} from '../constants/files';
import { siteMap } from '../constants/routes';
import { envSetting } from '../constants/envSetting';
import { personData, updatePersonData } from '../redux/actions/personData';
import { saveUserImage } from '../redux/actions/files'
import { setLoader } from '../redux/actions/shared'
import { setMessage } from '../redux/actions/message'
import { useNavigate } from 'react-router-dom';
import {
  fieldAttribute,
  isUndefinedNull,
  notUndefinedNull,
  sortElementInt,
  trimLowerCase
} from '../helpers/shared';
import {validateRequestType} from '../helpers/formData'
import {removeValidations} from '../helpers/files'
import { t } from 'i18next';
import EXIF from 'exif-js'
import { useForm, useFormContext } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { TIER_VALUES_EDIT } from '../redux/types/tier';
import { useParams } from 'react-router-dom';
import documentIconSource from '../assets/images/shared/pdf-file-icon.svg';
import { isLendecyApp, isSpeedForm } from '../helpers/base';
import { hiddenField } from '../constants/form';

/**
 * Change values to fields
 * @param {Object} field
 * @param {String} type
 * @returns
 */
export const useFile = (field, type) => {
  const { codeTier } = useParams();
  const { setValue, getValues } = useFormContext();
  const dispatch = useDispatch();
  const uniqueName = `${field.unique_name || field.file_name}__id__${field.id}`;

  const fileSizeLimit = Math.round(parseInt(
    type === 'document' || type === 'image' ? envSetting.fileSize : (
      type === 'video' && envSetting.videoSize)) / Math.pow(1024, 2), 2);

  let newImgFileType = typeImageFiles;
  if(codeTier === 'advanced'){ // Modifying the accepted file types, based on its tier.
    newImgFileType = newImgFileType.filter(imgType => !imgType.includes('pdf'));
  }


  const { areDocumentsFetched, documentsFetched } = useSelector(state => state.base)
  // * Fix for re-filling the fields included in the 'required' documents, answer of the 'documents-condition' endpoint.
  useEffect(() => {
    if (documentsFetched?.some(doc => uniqueName.includes(doc))) { 
      setTimeout(async () => {
        //debugger
        const currentValue = getValues(uniqueName);
        const values = getValues()
        const snapshotValue = values?.[uniqueName];
        const hasLiveValue = notUndefinedNull(currentValue) && currentValue !== '' &&
          currentValue !== hiddenField;
        if (!hasLiveValue && snapshotValue !== undefined && snapshotValue !== hiddenField || uniqueName.includes('file')) {
          // debugger
          if (!snapshotValue) {

            try {
              const imgName = "image-" + uniqueName.split('__id__')?.[0]
              const imgPreviewElem = document.querySelectorAll(`[data-image="${imgName}"]`)[0]
              const inputElement = document.getElementsByName(`${uniqueName}`)[0]

              if (imgPreviewElem) {
                const blobUrl = imgPreviewElem.src
                // Convert blob URL → Blob
                const response = await fetch(blobUrl);
                const blob = await response.blob();
                // Create File (Blob → File)
                const file = new File([blob], `${ field.file_name || field.unique_name }`, {
                  type: blob.type || "image/jpeg",
                  lastModified: Date.now(),
                });
                setValue(uniqueName, file);

                // ? Use transferer trick to pass files to inputs
                const transferer = new DataTransfer()
                transferer.items.add(file)
                inputElement.files = transferer.files

              }
            } catch (error) {
              console.error(error)
            }

      
          }


        }
      }, uniqueName.includes('file') ? 2000 : 100);
    } 
  }, [areDocumentsFetched, documentsFetched, documentsFetched?.length]);

  const onChange = ({ target: { files: comingFiles } }) => {
    if (comingFiles) {
      const [file] = comingFiles;
      if (file?.size) {
        const size = file.size;
        const typeFile = file.type;
        let error = false;

        if ((size > envSetting.fileSize) && (
          type === 'image' || type === 'document')) {
          dispatch(setMessage(
            t("files.errors.maxFileSize", { size: fileSizeLimit }), 'error'));
          error = true;
        } else if ((type === 'image' || type === 'document') && (
          newImgFileType.findIndex(item => item === typeFile) < 0)) {
          dispatch(setMessage(t("files.errors.typeFileNotAllowed"), 'error'));
          error = true;
        } else if (type === 'video' && size > envSetting.videoSize) {
          dispatch(setMessage(
            t("files.errors.maxVideoSize", { size: fileSizeLimit }), 'error'));
          error = true;
        } else if (type === 'video' && (typeVideoFiles.findIndex(
          item => item === typeFile) < 0)) {
          dispatch(setMessage(t("files.errors.typeFileNotAllowed"), 'error'));
          error = true;
        }

        if (!error) {
          const [currentFile] = Array.prototype.slice.call(comingFiles);
          const imageChange = fieldAttribute(
            'data-image', `image-${field.unique_name}`);
          const videoChange = fieldAttribute(
            'data-video', `video-${field.unique_name}`);
          field.file_size = currentFile?.size;
          field.input_file = true;
          if (imageChange) imageChange.classList.remove('d-none');
          if (videoChange) videoChange.classList.add('d-none');
          if (type === 'video') {
            //* Uncomment next 2 lines if need to use FileInputButton component 
            // const videoChange = fieldAttribute(
            //   'data-video', `video-${field.unique_name}`);
            let videoChange = fieldAttribute(
              'data-video', `video-${field.unique_name}-preview`);
            videoChange?.classList.remove('d-none');
            if (videoChange){
              videoChange.src = URL.createObjectURL(file);
            } else {
              videoChange = fieldAttribute('data-video', `video-${field.unique_name}`);
              videoChange.src = URL.createObjectURL(file);
            }
            videoChange?.classList.remove('d-none')
            imageChange?.classList.add('d-none');
          }
          if (type === 'image') {
            if (file.type === 'application/pdf') {
              imageChange.src = documentIconSource;
            } else {
              imageChange.src = URL.createObjectURL(file);
            }
            fixImage(currentFile, (newImage) => {
              const transferer = new DataTransfer();
              const input = fieldAttribute('data-unique-name', `${field.unique_name || field.file_name}`)
              transferer.items.add(newImage);
              setValue(uniqueName || field.file_name, currentFile)
              input.files = transferer.files;
            });
          }
        } else {
          setValue(uniqueName || field.file_name, '');
        }
      }
    }
  };

  const fixImage = (file, callback) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      const img = new Image();
      img.src = e.target.result;
      img.onload = function() {
        EXIF.getData(img, function() {
          // const orientation = EXIF.getTag(this, 'Orientation') || 1;
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          canvas.width = width;
          canvas.height = height;

          ctx.save();
          ctx.transform(1, 0, 0, 1, 0, 0);

          ctx.drawImage(img, 0, 0);
          ctx.restore();

          // Convert canvas to Blob and create new file
          canvas.toBlob(function(blob) {
            const newImage = new File([blob], file.name, { type: file.type });
            callback(newImage);
          }, file.type);
        });
      };
    };
    reader.readAsDataURL(file);
  };

  return { onChange, uniqueName, fileSizeLimit };
};

/**
 * Get fields to files
 * @param {Object} data
 * @returns
 */
export const useFilesFields = data => {
  const [tierFieldsFile, setTierFieldsFile] = useState([]);
  const [fileFields, setFileFields] = useState([]); // seem to hold all of the 'fields' related to the received files ('data')
  const { requestLanguage } = useSelector(state => state.base);
  const {
    field: fields,
    tier_field: tierField,
    field_category: fieldCategory,
    document_type: documentTypes
  } = useSelector(state => state.staticData[`data_${trimLowerCase(requestLanguage)}`]);

  const getFields = useCallback(() => {
    const identityData = sortElementInt(fieldCategory.filter(
      item => item.unique_name.includes(nameFormat.identityData)), 'id');
    const tierFields = sortElementInt(tierField, 'order');
    let categories = [];
    let fieldAll = [];

    data.forEach(item => {
      let category = [];
      let documentType = [];
      let videoMessage;

      if (notUndefinedNull(item.client_document_type_id)) {
        const index = documentTypes.findIndex(
          element => item.client_document_type_id === element.document_type_id);
        if (index >= 0) {
          category = identityData.filter(
            element => element.unique_name === trimLowerCase(
              `${nameFormat.identityData}${documentTypes[index].code}`)).pop();
          documentType = documentTypes[index];
        }
      } else {
        if (!item?.file_name?.includes('spouse')) {
          category = fieldCategory.filter(
            element => element.unique_name === trimLowerCase(
              nameFormat.identityProtectionData)).pop();
          if (item.file_name.includes(videoFile)) {
            videoMessage = fields.filter(element => element.unique_name.includes(
              userFilesCode.videoMessage)).pop();
          }
        } else {
          category = fieldCategory.filter(
            element => element.unique_name === trimLowerCase(
              nameFormat.spouseInformation)).pop();
        }
      }

      const index = categories.findIndex(
        current => current.category.id === category.id);
      if (category?.id) {
        if (category?.show_category !== true) category[
          'show_category'] = item.show_category;
        const tierCategoryFile = sortElementInt(tierFields.filter(
          element => element.field_category === category?.id), 'order');
        tierCategoryFile.forEach(element => {
          const iField = fields.findIndex(
            current => element.field === current.id);
          if (iField >= 0) {
            const field = removeValidations(
              fields[iField], videoMessage, category, item, element, categories);
            const iAll = fieldAll.findIndex(current => current.id === field.id);
            if (iAll < 0) {
              fieldAll.push(field);
              element['data'] = field;
            } else {
              if (category?.show_category !== true) {
                fieldAll[iAll] = field;
                const iCategory = categories[index]?.fields.findIndex(
                  current => current.field === field.id);
                if (iCategory >= 0) {
                  categories[index].fields[iCategory].data = field;
                }
              }
            }
            element.data['category'] = { 'field_category': category.id };
          }
        });
        const [tierCategoryFileOrder] = tierCategoryFile;
        if (index < 0) {
          categories.push({
            category,
            documentType,
            fields: tierCategoryFile,
            order: tierCategoryFileOrder.order,
          });
        }
      }
    });

    setTierFieldsFile(sortElementInt(categories, 'order'));
    setFileFields(fieldAll);
  }, [data, documentTypes, fieldCategory, fields, tierField]);

  useEffect(() => {
    getFields();
  }, [getFields]);

  // ? filtering Fields (fileFields and tierFieldFile) by tier
  const { lastTier } = useSelector(state => state.tier)

  useEffect(() => {
    if (lastTier.unique_name === 'speed_form') {
      setFileFields(prevFileFields => prevFileFields.filter(fileField => fileField.unique_name.includes('_sform')))
      setTierFieldsFile(prevTierFieldsFile => prevTierFieldsFile.map(tierFieldFile => { 
          return { 
            ...tierFieldFile, 
            fields: tierFieldFile?.fields?.filter(field => field?.data?.unique_name?.includes('_sform'))
          } 
        }
      ))
    }
  }, [lastTier, getFields])


  return { tierFieldsFile, fileFields };
};

/**
 * Get expired/rejected fields
 * @param {String} codeTier
 * @returns
 */
export const usePersonFiles = codeTier => {
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const { data: {
    documents,
    user_files: userFiles
  } } = useSelector(state => state.personData);
  const { requestLanguage, expiredFiles, rejectedFiles } = useSelector(
    state => state.base);
  const { document_type: documentTypes, field: fields } = useSelector(
    state => state.staticData[`data_${trimLowerCase(requestLanguage)}`]);
  const { appOrigin } = useSelector(state => state.user)

  if (codeTier === fileStatus.expired) {
    if (!expiredFiles) navigate(siteMap.homepage.path);
  }

  if (codeTier === fileStatus.rejected) {
    if (!rejectedFiles) navigate(siteMap.homepage.path);
  }

  const getFields = useCallback(() => {
    if (codeTier === fileStatus.expired) {
      const fileExpired = [];
      documents.forEach(item => {
        fileExpired.push(item);
        if (item.expiration_date_notified_period === fileStatus.expired) {
          fileExpired[fileExpired.length - 1]['show_category'] = true;
        } else {
          fileExpired[fileExpired.length - 1]['show_category'] = false;
        }
      });
      setFiles(fileExpired);
    }

    if (codeTier === fileStatus.rejected) {
      const fileRejected = [];
      const isLendecy = isLendecyApp()
      const isSpeed = isSpeedForm()

      userFiles.forEach(item => {
        if (avatarImage !== item.file_name) {
          fileRejected.push(item);
          let fieldRequest
          let fieldRequests = fields.filter(element => JSON.parse(
            element?.request_type)?.name === item.file_name);

          if (isLendecy) {
            fieldRequest = fieldRequests.filter(field => field.unique_name.includes('_ibv'))?.pop();
          } else if (isSpeed) {
            fieldRequest = fieldRequests.filter(field => field.unique_name.includes('_sform'))?.pop();
          } else {
            fieldRequest = fieldRequests.filter(field => !field.unique_name.includes('_ibv') && !field.unique_name.includes('_sform'))?.pop();
          }

          if (notUndefinedNull(fieldRequest.request_type)) {
            const requestType = JSON.parse(fieldRequest.request_type);
            if (userFilesCode[requestType.name]) {
              const fileRejected = documentTypes.filter(element => trimLowerCase(
                element.code) === trimLowerCase(userFilesCode[
                  requestType.name]))?.pop();
              item['client_document_type_id'] = fileRejected?.document_type_id;
              item['field_request'] = fieldRequest;
            }
          }
          if (item.user_file_status && trimLowerCase(
            item.user_file_status.unique_description) === fileStatus.rejected) {
            fileRejected[fileRejected.length - 1]['show_category'] = true;
          } else {
            fileRejected[fileRejected.length - 1]['show_category'] = false;
          }
        }
      });
      setFiles(fileRejected);
    }
  }, [codeTier, documents, userFiles, fields, documentTypes]);

  useEffect(() => {
    getFields();
  }, [getFields]);

  return { files };
};

/**
 * Hook to form files
 * @param {Object} fileFields
 * @param {Object} schemaTier
 * @returns
 */
export const useFormFiles = (fileFields, schemaTier) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { firstProductRequestId, lastProductRequestId, userIdBifrost } = useSelector(
    state => state.user);
  const { defaultValuesTier } = useSelector(state => state.tier);
  const { data: { id: userId } } = useSelector(state => state.personData);
  const { location } = useSelector(state => state.base);
  const methods = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(yup.object(schemaTier)),
    shouldFocusError: false,
  });
  const [tierFieldsEdit, setTierFieldEdit] = useState(null);

  // Effect runs when user state is updated
  useEffect(() => {
    // Reset form
    methods.reset(defaultValuesTier);
  }, [defaultValuesTier, methods]);

  useEffect(() => {
    if (isUndefinedNull(tierFieldsEdit) && notUndefinedNull(defaultValuesTier)) {
      dispatch({ type: TIER_VALUES_EDIT, payload: defaultValuesTier });
      setTierFieldEdit(defaultValuesTier);
    }
  }, [dispatch, defaultValuesTier, tierFieldsEdit]);

  const onSubmit = async values => {
    try {
      dispatch(setLoader(true));
      const formObject = validateRequestType(values, fileFields, userId, false);
      if (formObject.isElement || formObject.isMedia) {
        formObject.isMedia = false;
        formObject.elements['country_code'] = location;
        const response = await dispatch(personData(
          formObject, userIdBifrost, firstProductRequestId));
        if (response && !response.error) {
          if (await dispatch(saveUserImage(userIdBifrost, formObject.formMedia, false, true))) {
            if (await dispatch(updatePersonData(userIdBifrost, lastProductRequestId))) {
              dispatch(setMessage(t("common.filesSubmmited"), 'success'));
              navigate(siteMap.homepage.path);
              dispatch(setLoader(false));
            }
          } else {
            dispatch(setLoader(false));
          }
        } else {
          dispatch(setLoader(false));
        }
      } else {
        dispatch(setMessage(t("common.filesSubmmitedError"), 'error'));
        dispatch(setLoader(false));
      }
    } catch (error) {
      console.error('onSubmit in useFormFiles: ', error);
      dispatch(setMessage(t("common.filesSubmmitedError"), 'error'));
      dispatch(setLoader(false));
    }
  };

  const { trigger } = methods;
  const onValidate = async () => {
    try {
      if (await trigger()) {
        onSubmit(methods.getValues());
      } else {
        // scroll top
        window.scrollTo({ top: 0, behavior: 'smooth' });
        dispatch(setMessage(t("common.missingFields"), 'error'));
        
      }
    } catch (error) {
      console.error('onValidate in useFormFiles: ', error);
    }
  }

  return { methods, onSubmit, onValidate };
};